import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {ParentService} from '../../services/parent.service';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {ConfirmDialogComponent} from '../shared/confirm-dialog/confirm-dialog.component';
import {Router} from '@angular/router';

@Component({
    selector: 'app-parent-student-registration',
    templateUrl: './parent-student-registration.component.html',
    styleUrls: ['./parent-student-registration.component.scss']
})
export class ParentStudentRegistrationComponent implements OnInit {
    studentFormGroup: FormGroup;
    parentFormGroup: FormGroup;
    student = {
        firstName: '',
        lastName: '',
        birthday: '',
        email: ''
    };

    constructor(private formBuilder: FormBuilder,
                public toastService: ToastMessagesService,
                private parentService: ParentService,
                public router: Router,
                public dialog: MatDialog) {
    }

    ngOnInit(): void {
        this.studentFormGroup = this.formBuilder.group({
            studentEmail: ['', Validators.required],
            studentId: ['', Validators.required]
        });
        this.parentFormGroup = this.formBuilder.group({
            first_name: ['', Validators.required],
            last_name: ['', Validators.required],
            email: ['', Validators.required],
            telephone: ['', Validators.required],
            password: ['', Validators.required],
            telephoneOTP: ['', Validators.required],
            confirmedMobileCode: ['', Validators.required],
            emailOTP: ['', Validators.required],
            confirmedEmailCode: ['', Validators.required],
            parentType: ['', Validators.required]
        });
    }

    async completeRegistration() {
        try {
            const parentData = {
                studentId: this.studentFormGroup.controls.studentId.value,
                parent: {
                    first_name: this.parentFormGroup.controls.first_name.value,
                    last_name: this.parentFormGroup.controls.last_name.value,
                    email: this.parentFormGroup.controls.email.value,
                    telephone: this.parentFormGroup.controls.telephone.value,
                    password: this.parentFormGroup.controls.password.value,
                    parentType: this.parentFormGroup.controls.parentType.value,
                }
            };

            await this.parentService.registerParent(parentData);
            this.toastService.toastMessages(`Η εγγραφή σας ολοκληρώθηκε με επιτυχία`);
            setTimeout(async () => {
                await this.router.navigate(['login']);
            }, 1500);
        } catch (e) {
            this.toastService.toastErrorMessage(e.message);
        }
    }

    promptRegistration() {
        const confirm = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: 'Εγγραφή γονέα',
                message: 'Είστε σίγουροι ότι ολα τα στοιχεία είναι σωστά?'
            }
        });

        confirm.afterClosed().subscribe(async result => {
            if (result) {
                await this.completeRegistration();
            }
        });
    }

    isButtonDisabled() {
        return !this.studentFormGroup.valid;
    }

    isParentButtonDisabled() {
        return !this.parentFormGroup.valid;
    }

    setStudentInfo($event: any) {
        this.student = $event;
    }

    cancelRegistrationPrompt() {
        const confrim = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: 'Ακύρωση εγγραφής γονέα',
                message: 'Όλες οι πληροφορίες που εισάγαγτε θα χαθούν. Είστε σίγουροι ότι θέλετε να ακυρώσετε την εγγραφή σας?'
            }
        });

        confrim.afterClosed().subscribe((async result => {
            if (result) {
                await this.router.navigate(['/login']);
            }
        }));
    }
}
